module.exports = __webpack_public_path__ + "static/media/DarthVader.c4378af8.jpg";